module.exports = __webpack_public_path__ + "img/矩形 30 拷贝 5@2x.b7a0b5bd.png";